import { Container } from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";
import Title from "../../common/title/title.components";
import StyledWrapper from "./partners.styles";

import {
  mainPartners,
  partners,
  separetedPartners,
  specialPartners,
} from "../../constant/partners.constant";
import PartnersGrid from "./components/partners-grid.components";

const PartnersPage = () => {
  const { t } = useAppTranslation();

  return (
    <StyledWrapper>
      <Container className="partners-content-holder">
        <Title className="partners-title" text={t("PartnersPage.title")} />
        <PartnersGrid
          tier="main"
          list={mainPartners}
          title={t("PartnersPage.mainPartners")}
        />
        <PartnersGrid
          tier="special"
          list={specialPartners}
          title={t("PartnersPage.specialPartners")}
        />
        <PartnersGrid
          tier="partner"
          list={partners}
          title={t("PartnersPage.partners")}
        />
        <PartnersGrid
          tier="separated"
          list={separetedPartners}
          title={t("")}
        />
      </Container>
    </StyledWrapper>
  );
};

export default PartnersPage;
